import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formState, setFormState] = useState({ name: '', email: '', message: '', service: 'cac' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="pt-32 pb-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-20">
          <div>
            <h1 className="text-5xl font-display font-bold text-slate-900 dark:text-white mb-6">Talk to an <span className="text-primary italic">Expert.</span></h1>
            <p className="text-xl text-slate-600 dark:text-slate-400 mb-12">Whether you have a quick question or need a full audit, our compliance team is here to help.</p>
            
            <div className="space-y-8">
              {[
                { icon: 'call', title: 'Call Us', value: '+2347089903452', sub: 'Available Mon - Fri, 9am - 5pm' },
                { icon: 'mail', title: 'Email Us', value: 'finrackbizsolutions@gmail.com', sub: 'We reply within 2 hours' },
                { icon: 'location_on', title: 'Visit Us', value: 'Lekki Phase 1, Lagos', sub: 'By appointment only' }
              ].map((item, i) => (
                <div key={i} className="flex gap-6">
                  <div className="w-14 h-14 bg-slate-100 dark:bg-slate-800 rounded-2xl flex items-center justify-center shrink-0">
                    <span className="material-symbols-rounded text-primary text-2xl">{item.icon}</span>
                  </div>
                  <div>
                    <h3 className="text-sm font-black uppercase tracking-widest text-slate-400 mb-1">{item.title}</h3>
                    <p className="text-xl font-bold text-slate-900 dark:text-white mb-1">{item.value}</p>
                    <p className="text-sm text-slate-500">{item.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white dark:bg-slate-800 p-8 lg:p-12 rounded-[40px] shadow-2xl border border-slate-100 dark:border-slate-700">
            {submitted ? (
              <div className="h-full flex flex-col items-center justify-center text-center py-12">
                <div className="w-20 h-20 bg-green-100 dark:bg-green-900/30 text-green-600 rounded-full flex items-center justify-center mb-6">
                  <span className="material-symbols-rounded text-4xl">check_circle</span>
                </div>
                <h3 className="text-2xl font-bold mb-2">Message Sent!</h3>
                <p className="text-slate-500">We'll get back to you shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">Full Name</label>
                  <input 
                    required
                    className="w-full px-4 py-4 bg-slate-50 dark:bg-slate-900 border-none rounded-2xl focus:ring-2 focus:ring-primary text-slate-900 dark:text-white" 
                    placeholder="Enter your name"
                    value={formState.name}
                    onChange={e => setFormState({...formState, name: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">Email Address</label>
                  <input 
                    required
                    type="email"
                    className="w-full px-4 py-4 bg-slate-50 dark:bg-slate-900 border-none rounded-2xl focus:ring-2 focus:ring-primary text-slate-900 dark:text-white" 
                    placeholder="name@company.com"
                    value={formState.email}
                    onChange={e => setFormState({...formState, email: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">Service Interested In</label>
                  <select 
                    className="w-full px-4 py-4 bg-slate-50 dark:bg-slate-900 border-none rounded-2xl focus:ring-2 focus:ring-primary text-slate-900 dark:text-white"
                    value={formState.service}
                    onChange={e => setFormState({...formState, service: e.target.value})}
                  >
                    <option value="cac">CAC Registration</option>
                    <option value="tax">Tax Compliance</option>
                    <option value="bookkeeping">Monthly Bookkeeping</option>
                    <option value="other">Other Inquiry</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">Message</label>
                  <textarea 
                    rows={4}
                    className="w-full px-4 py-4 bg-slate-50 dark:bg-slate-900 border-none rounded-2xl focus:ring-2 focus:ring-primary text-slate-900 dark:text-white" 
                    placeholder="How can we help?"
                    value={formState.message}
                    onChange={e => setFormState({...formState, message: e.target.value})}
                  />
                </div>
                <button type="submit" className="w-full py-5 bg-primary text-white font-bold rounded-2xl shadow-xl shadow-primary/20 hover:scale-[1.02] transition-all">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;